import React from 'react';
import logoInvertedMinimized from '../assets/logo-inverted-minimized.svg';
import logoInverted from '../assets/logo-inverted.svg';
import logoStandard from '../assets/logo-standard.svg';

const Logo = (props) => {
  let logo, height;

  if (props.type === 'standard') {
    logo = logoStandard;
    height = 53;
  } else if (props.type === 'inverted') {
    logo = logoInverted;
    height = 52;
  } else if (props.type === 'inverted-minimized') {
    logo = logoInvertedMinimized;
    height = 43;
  }

  if (props.height) {
    height = props.height;
  }

  return <img alt={logo} src={logo} height={height} style={{ height: height }} />;
};

export default Logo;
